
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oranges/pricing",
      function () {
        return require("private-next-pages/oranges/pricing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oranges/pricing"])
      });
    }
  